import { FunctionComponent, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { DraftConfiguration } from '@/types';
import { getDesignImageUrl } from '@/utils/imageUrls/getDesignImageUrl';
import {
  isDraftDesignConfiguration,
  isDraftSpecialTextConfiguration,
} from '@/model/configuration/isDraftConfigurationType';
import { selectConfigurations } from '@/redux/draft/getters/selectConfigurations';
import './ConfigurationsPreview.scss';

interface ItemProps {
  configuration: DraftConfiguration;
}

const ConfigurationsPreviewItem: FunctionComponent<ItemProps> = ({ configuration }) => {
  let preview: ReactNode;
  let isLight = false;
  if (isDraftDesignConfiguration(configuration)) {
    const design = configuration.design;
    const src = getDesignImageUrl(design.id, {
      width: 150,
      height: 150,
    });
    preview = <img src={src} alt={design.name} />;
    isLight = Boolean(design.backgroundColor);
  } else if (isDraftSpecialTextConfiguration(configuration)) {
    preview = <img src={configuration.task.previewUrl} alt={configuration.text.content} />;
  } else {
    preview = (
      <span style={{ fontFamily: configuration.text.style.font.identifier }}>
        {configuration.text.content}
      </span>
    );
  }

  return (
    <li
      className={cn('configurations-preview__item', {
        'configurations-preview__item--light': isLight,
      })}
    >
      {preview}
    </li>
  );
};

interface Props {
  cids: number[];
}

export const ConfigurationsPreview: FunctionComponent<Props> = ({ cids }) => {
  const configurations = useSelector(selectConfigurations).filter(({ cid }) => cids.includes(cid));
  return (
    <div className="configurations-preview">
      <ul className="configurations-preview__list">
        {configurations.map((configuration) => (
          <ConfigurationsPreviewItem configuration={configuration} key={configuration.cid} />
        ))}
      </ul>
    </div>
  );
};
